import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DrawerService {
    private drawerOpenSubject = new BehaviorSubject<boolean>(false);
    drawerOpen$ = this.drawerOpenSubject.asObservable();

    toggleDrawer() {
        this.drawerOpenSubject.next(!this.drawerOpenSubject.value);
    }

    openDrawer() {
        this.drawerOpenSubject.next(true);
    }

    closeDrawer() {
        this.drawerOpenSubject.next(false);
    }
}
